/* src/app/modules/product-labels/label-added-by-smart-filter-badge/label-added-by-smart-filter-badge.component.scss */
:host .label-added-by-smart-filter-icon {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=label-added-by-smart-filter-badge.component.css.map */
